import { useDevice } from 'app/agriculture/queries/devices/useDevice';
import { useCallback } from 'react';
import { IconBaseProps } from 'react-icons';
import { DeviceIcon } from 'app/agriculture/icons/devices/DeviceIcon';

export function useDeviceIcon({ deviceId }: { deviceId: string }) {
    const device = useDevice({ deviceId });
    return useCallback(
        (props: IconBaseProps) => {
            return <DeviceIcon {...props} deviceType={device.deviceType} />;
        },
        [device.deviceType],
    );
}
